$('.video__play').on('click', function () {
    $('.video__image, .video__play').hide();
    $('.video__item').trigger('play');
});